import React from 'react';
import { RedirectAction } from '../../../../types/qr.types';
import { Input } from '../../../Input';

interface RedirectActionEditorProps {
  action: RedirectAction;
  onChange: (action: RedirectAction) => void;
}

export function RedirectActionEditor({ action, onChange }: RedirectActionEditorProps) {
  return (
    <div className="space-y-2">
      <label className="block text-sm font-medium text-[--clinqr-text-secondary]">Redirect URL</label>
      <Input
        type="text"
        placeholder="example.com/page"
        value={action.url}
        onChange={(e) => onChange({ ...action, url: e.target.value })}
      />
      <p className="text-sm text-[--clinqr-text-muted]">
        When this rule matches, users will be redirected to this URL.
      </p>
    </div>
  );
}
